import { useEffect } from "react";
import { playAcidRiff } from "@/acid";

export const useAcidSounds = (on) => {
  useEffect(() => {
    if (!on) return;
    let timer, riff;
    const loop = () => {
      riff = playAcidRiff();
      timer = setTimeout(loop, riff.len * 1000 + 3000 + Math.random() * 9000);
    };
    timer = setTimeout(loop, 300);
    return () => { clearTimeout(timer); riff?.stop(); };
  }, [on]);
};
